import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Countdown from 'react-countdown-now';
import { padNumber, fromIso9075DateString } from 'utils/functions';
import { isAuthenticated } from 'utils/auth';
import { getMaintenanceMode, setMaintenanceMode } from 'utils/localStorage';
import { setMaintenanceCookie, clearMaintenanceCookie } from 'utils/cookies';
import LogoImage from 'resources/HOR-White_WCCdotcom.png';
import './MaintenanceMode.css';

const TIMER_LIMIT_MINUTES = 5;
const FETCH_OPTIONS = {
  credentials: 'same-origin', // For maintenance cookie
  mode: 'cors',
  cache: 'no-cache'
};

const timerRenderer = ({ hours, minutes, seconds }) => {
  const minutesRemaining = minutes + hours * 60;
  return minutesRemaining > TIMER_LIMIT_MINUTES ? (
    <span>
      Estimated time until completion: {padNumber(hours)}:{padNumber(minutes)}:{padNumber(seconds)}
    </span>
  ) : null;
};

class MaintenanceMode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maintenanceMode: getMaintenanceMode(),
      accessFormOpen: false,
      accessFormCode: ''
    };

    this.requery = false;
    this.wasAuthenticated = isAuthenticated();
    this.lastPath = undefined;

    this.toggleAccessForm = this.toggleAccessForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.queryMaintenanceMode();
  }

  componentWillReceiveProps(nextProps) {
    const { location } = nextProps;
    const pathname = location && location.pathname;
    const isAuth = isAuthenticated();

    if (!isAuth && (this.wasAuthenticated || pathname !== this.lastPath)) {
      this.requery = true;
    }

    if (this.requery && pathname !== '/logout') {
      this.requery = false;
      this.queryMaintenanceMode();
    }

    this.wasAuthenticated = isAuth;
    this.lastPath = pathname;
  }

  toggleAccessForm(event) {
    const open = this.state.accessFormOpen;
    this.setState({ accessFormOpen: !open });
    if (open) {
      this.handleSubmit(event);
    }
  }

  handleChange(event) {
    this.setState({ accessFormCode: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    const code = this.state.accessFormCode.trim();
    if (code) {
      setMaintenanceCookie(code);
      window.location.reload();
    }
  }

  render() {
    const { enabled, message, estimatedEnd } = this.state.maintenanceMode;
    if (!enabled) {
      return this.props.children;
    }

    const { accessFormOpen, accessFormCode } = this.state;

    return (
      <div className="maintenance-mode-container">
        <Helmet>
          <title>Maintenance Downtime - Wind Creek Casino</title>
        </Helmet>
        <img className="logo" src={LogoImage} alt="Wind Creek Casino Logo" />
        <div className="title">
          SITE IS CURRENTLY UNAVAILABLE DUE TO MAINTENANCE
        </div>
        <div className="text">
          <div>
            {message &&
              message
                .split('\n')
                .filter(line => line.trim())
                .map((line, index) => <div key={index}>{line}</div>)}
          </div>
          <div>
            <Countdown
              date={fromIso9075DateString(estimatedEnd)}
              renderer={timerRenderer}
            />
          </div>
          <div>Please check back later.</div>
        </div>
        <div className="access-container">
          {accessFormOpen && (
            <form onSubmit={this.handleSubmit}>
              <input
                className="access-form"
                type="password"
                value={accessFormCode}
                onChange={this.handleChange}
                autoFocus
              />
            </form>
          )}
          <button onClick={this.toggleAccessForm} className="btn toggle-button">
            <i className={`fa fa-${accessFormOpen ? 'un' : ''}lock fa-fw`} />
          </button>
        </div>
      </div>
    );
  }

  queryMaintenanceMode() {
    // GraphQL endpoint is disabled during maintenance mode, so fetch directly
    fetch(process.env.REACT_APP_API_URI + '/maintenance', FETCH_OPTIONS)
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return Promise.reject();
      })
      .then(json => {
        const curr = this.state.maintenanceMode;
        if (
          'enabled' in json &&
          (json.enabled !== curr.enabled ||
            json.message !== curr.message ||
            json.estimatedEnd !== curr.estimatedEnd)
        ) {
          setMaintenanceMode(json);
          this.setState({ maintenanceMode: json });

          if (json.enabled) {
            // Cookie must be wrong, clear it to ease CloudFront cache growth
            clearMaintenanceCookie();
          }
        }
      });
  }
}

export default withRouter(MaintenanceMode);



// WEBPACK FOOTER //
// ./src/containers/MaintenanceMode/index.js